import { render, staticRenderFns } from "./InnTextarea.vue?vue&type=template&id=77b5e7a6"
import script from "./InnTextarea.vue?vue&type=script&lang=js"
export * from "./InnTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports